import * as React from "react";
const SvgUnknown = (props) => /* @__PURE__ */ React.createElement("svg", { id: "uuid-efdcf75d-eabd-4c8a-8dd5-8369ab635cc9", "data-name": "Warstwa 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "m5.25,7.77v12.23c0,.97.78,1.75,1.75,1.75h10c.97,0,1.75-.78,1.75-1.75V4c0-.97-.78-1.75-1.75-1.75h-6.61c-.5,0-.97.21-1.3.58l-3.39,3.77c-.29.32-.45.74-.45,1.17Z", style: {
  fill: "#e5e5e5",
  stroke: "#e5e5e5",
  strokeWidth: ".5px"
} }));
export default SvgUnknown;
